import i18next from "i18next";
import { SupportedLanguages, getNormalizedLanguageCode } from "@libs/i18next/language";

export const translate = (
  translationData: Record<string, any> | undefined,
  count?: number,
  standardLangCode: SupportedLanguages = SupportedLanguages.EN
): string => {
  const fields = translationData ?? {};

  const langId = getNormalizedLanguageCode(i18next.language);
  const codes = [langId, standardLangCode.code, "en", ...Object.keys(fields)];
  const priorities =
    count === undefined ? ["default", "singular", "plural"] : count > 1 ? ["plural", "default", "singular"] : ["singular", "default", "plural"];

  for (const code of codes) {
    for (const priority of priorities) {
      const codeData = fields[code];
      if (codeData) {
        if (priority === "default" && codeData.default) return codeData.default;
        if (priority === "singular" && codeData.singular) return codeData.singular;
        if (priority === "plural" && codeData.plural) return codeData.plural;
      }
    }
  }
  return "";
};
